// Third-party
import React from 'react';

// Components
import Search from './Search';
import LegacySearch from './LegacySearch';
import Screener from './Screener';

// Hooks
import useThemeVersion from '@/hooks/useThemeVersion';
import useEnhancedScreener from '@/hooks/useEnhancedScreener';

const SearchRouter: React.FC = () => {
  const { isLightVersion } = useThemeVersion();
  const { shouldUseEnhancedScreener } = useEnhancedScreener();

  if (!isLightVersion) {
    return <LegacySearch />;
  }

  if (shouldUseEnhancedScreener) {
    return <Screener />;
  }

  return <Search />;
};

export default SearchRouter;
